import { getClosedModalState, getBookmarksState, getDefaultEmailRegistrationState, globalAlerts } from './userDuckUtils';
export default (state, action, _ref) => {
  let {
    initialState,
    types
  } = _ref;
  switch (action.type) {
    case types.CLEAR_UI:
      {
        return {
          ...state,
          ...getClosedModalState(state)
        };
      }
    case types.CLEAR_GLOBAL_ALERT:
      {
        return {
          ...state,
          globalAlert: null
        };
      }
    case types.CLEAR_LOCATION:
      {
        return {
          ...state,
          location: {
            city: null,
            state: null,
            zip: null
          }
        };
      }
    case types.SET_LOCATION:
      {
        return {
          ...state,
          location: {
            ...state.location,
            ...action.payload
          }
        };
      }
    case types.CLEAR_PROFILE:
      {
        const bookmarks = state.bookmarks || {};
        const loggedOutState = {
          ...initialState,
          // preserve some user props on logout
          bookmarks: {
            ...initialState.bookmarks,
            search: {
              ...bookmarks.search,
              title: null
            }
          },
          location: state.location,
          recommendedInventory: state.recommendedInventory,
          history: state.history,
          showUserState: state.showUserState,
          profile: {
            ...initialState.profile
          }
        };
        return {
          ...state,
          ...loggedOutState
        };
      }
    case types.SET_PROFILE:
      {
        return {
          ...state,
          profile: {
            ...state.profile,
            ...action.payload
          }
        };
      }
    case types.ADD_EMAIL_ALERTS_ITEM:
      {
        const updatedEmailAlerts = [...state.bookmarks.emailAlerts];

        // Ensure deduped id from existing collection
        if (!updatedEmailAlerts.includes(action.payload)) {
          updatedEmailAlerts.push(action.payload);
        }
        return {
          ...getClosedModalState(),
          ...getBookmarksState(state, {
            emailAlerts: updatedEmailAlerts
          })
        };
      }
    case types.ADD_SAVED_SEARCH_ITEM:
      {
        const updatedSearch = [...state.bookmarks.searchIds];

        // Ensure deduped id from existing collection
        if (!updatedSearch.includes(action.payload)) {
          updatedSearch.push(action.payload);
        }
        return getBookmarksState(state, {
          searchIds: updatedSearch
        });
      }
    case types.REMOVE_EMAIL_ALERTS_ITEM:
      {
        const updatedEmailAlerts = state.bookmarks.emailAlerts.filter(id => id !== action.payload);
        const newState = {
          ...getClosedModalState(),
          ...getBookmarksState(state, {
            emailAlerts: updatedEmailAlerts
          })
        };
        return newState;
      }
    case types.REMOVE_SAVED_SEARCH_ITEM:
      {
        let bookmarksState = getBookmarksState(state, {
          search: {}
        });
        if (state.bookmarks.searchIds && state.bookmarks.searchIds.includes(action.payload)) {
          const updatedSearchIds = state.bookmarks.searchIds.filter(id => id !== action.payload);
          bookmarksState = getBookmarksState(state, {
            searchIds: updatedSearchIds
          });
        }
        return {
          ...bookmarksState,
          showUpdateSavedSearch: false
        };
      }
    case types.SET_ALERTS_MODAL:
      {
        return {
          ...state,
          ...getClosedModalState(state),
          errorMessages: null,
          showUpdateAlertsModal: action.payload
        };
      }
    case types.CACHED_TEXT_ALERTS:
      {
        return {
          ...state,
          cachedTextAlerts: action.payload
        };
      }
    case types.SET_INVENTORY_BOOKMARKS:
      {
        return getBookmarksState(state, {
          inventoryBookmarks: action.payload
        });
      }
    case types.SET_EMAIL_ALERTS_ITEMS:
      {
        return getBookmarksState(state, {
          emailAlerts: action.payload
        });
      }
    case types.SET_SAVED_SEARCH_ITEM:
      {
        return getBookmarksState(state, {
          search: action.payload
        });
      }
    case types.SET_SAVED_SEARCH_IDS:
      {
        return getBookmarksState(state, {
          searchIds: action.payload
        });
      }
    case types.SET_SEARCH_BOOKMARKS:
      {
        return getBookmarksState(state, {
          searchBookmarks: action.payload
        });
      }
    case types.SET_SUBSCRIBE_SEARCH_ITEM:
      {
        const newState = {
          ...state,
          ...getDefaultEmailRegistrationState(),
          bookmarks: {
            ...state.bookmarks,
            subscribe: {
              ...action.payload
            }
          },
          showEmailSubscribeModal: true
        };
        return newState;
      }
    case types.SHOW_UPDATE_SAVED_SEARCH:
      {
        return {
          ...state,
          ...getClosedModalState(state),
          ...initialState.updateSavedSearch,
          showUpdateSavedSearch: true,
          updateSavedSearch: action.payload
        };
      }
    case types.HIDE_UPDATE_SAVED_SEARCH:
      {
        return {
          ...getClosedModalState(state)
        };
      }
    case types.SHOW_QUICK_SAVE_LIST:
      {
        return {
          ...state,
          ...getClosedModalState(state),
          showQuickSaveList: true
        };
      }
    case types.HIDE_QUICK_SAVE_LIST:
      {
        return {
          ...state,
          ...getClosedModalState(state)
        };
      }
    case types.SET_GLOBAL_ALERT:
      {
        const {
          key,
          message
        } = action.payload;
        const globalAlert = globalAlerts[key];
        if (message) {
          globalAlert.message = message;
        }
        return {
          ...state,
          globalAlert
        };
      }
    case types.SET_RECENT_INVENTORY:
      {
        return {
          ...state,
          history: {
            ...state.history,
            inventory: action.payload
          }
        };
      }
    case types.SET_ALERTS_ERROR:
      {
        return {
          ...state,
          errorMessages: action.payload
        };
      }
    case types.SET_UPDATE_SAVED_SEARCH_STATE:
      {
        return {
          ...state,
          updateSavedSearch: {
            ...state.updateSavedSearch,
            ...action.payload
          }
        };
      }
    case types.SET_RECOMMENDED_INVENTORY:
      {
        return {
          ...state,
          recommendedInventory: action.payload
        };
      }
    case types.HIDE_EMAIL_SUBSCRIBE_MODAL:
      {
        return {
          ...state,
          showEmailSubscribeModal: false,
          showEmailSubscribeSuccess: false,
          showEmailSubscribeFailure: false
        };
      }
    case types.SHOW_EMAIL_SUBSCRIBE_SUCCESS:
      {
        return {
          ...state,
          ...initialState.updateSavedSearch,
          showEmailSubscribeSuccess: true,
          emailRegistrationError: ''
        };
      }
    case types.SHOW_EMAIL_SUBSCRIBE_FAILURE:
      {
        return {
          ...state,
          showEmailSubscribeFailure: true,
          emailRegistrationError: ''
        };
      }
    case types.SHOW_BEST_DEALS_SUBSCRIBE_SUCCESS:
      {
        return {
          ...state,
          showBestDealsSubscribeSuccess: action.payload,
          bestDealsRegistrationError: ''
        };
      }
    case types.SHOW_BEST_DEALS:
      {
        return {
          ...state,
          showBestDeals: action.payload
        };
      }
    case types.SHOW_EMAIL_SUBSCRIBE_INLINE:
      {
        return {
          ...state,
          showEmailSubscribeInline: action.payload
        };
      }
    case types.SHOW_LIGHT_REGISTRATION_SERVER_ERROR:
      {
        return {
          ...state,
          emailRegistrationError: action.payload
        };
      }
    case types.SHOW_BEST_DEALS_REGISTRATION_SERVER_ERROR:
      {
        return {
          ...state,
          bestDealsRegistrationError: action.payload
        };
      }
    case types.SET_CANCEL_ALERTS_CONFIRMATION:
      {
        return {
          ...state,
          cancelAlerts: action.payload
        };
      }
    case types.SET_CANCEL_ACCOUNT_CONFIRMATION:
      {
        return {
          ...state,
          cancelAccount: action.payload
        };
      }
    case types.SHOW_CANCEL_ACCOUNT_SUCCESS:
      {
        return {
          ...state,
          cancelAccountSuccess: action.payload
        };
      }
    case types.SET_CANCEL_ACCOUNT_MODAL:
      {
        return {
          ...state,
          ...getClosedModalState(state),
          errorMessages: null,
          showUpdateCancelAccountModal: action.payload
        };
      }
    case types.SHOW_NEW_USER_MODAL:
      {
        return {
          ...state,
          showNewUserModal: action.payload
        };
      }
    case types.SHOW_USER_STATE:
      {
        return {
          ...state,
          showUserState: true
        };
      }
    case types.SET_LEAD_PROFILE:
      {
        return {
          ...state,
          leadProfile: {
            ...action.payload
          }
        };
      }
    case types.SET_MAX_QUICK_SAVES_LIMIT:
      {
        return {
          ...state,
          maxQuickSavesLimit: action.payload
        };
      }
    case types.UPDATE_SAVED_INVENTORY:
      {
        const {
          id,
          version
        } = action.payload;
        const bookmarkInventory = [...state.bookmarks.inventory];
        const index = bookmarkInventory.findIndex(_ref2 => {
          let {
            bookmarkId
          } = _ref2;
          return bookmarkId === id;
        });
        if (index > -1) {
          bookmarkInventory[index] = {
            ...bookmarkInventory[index],
            version
          };
        }
        return getBookmarksState(state, {
          inventory: bookmarkInventory
        });
      }
    case types.SET_PSX_NOTIFICATIONS_COUNT:
      {
        return {
          ...state,
          psxNotificationsCount: action.payload
        };
      }
    case types.SET_CARS_I_OWN_COUNT:
      {
        return {
          ...state,
          myCarsCount: action.payload
        };
      }
    case types.UPDATE_HAS_CHAT_PREVIOUSLY_VDP_LISTINGS:
      {
        return {
          ...state,
          hasChatPreviouslyVdpListings: [...(state?.hasChatPreviouslyVdpListings || []), action.payload]
        };
      }
    case types.SET_USER_EDIT_PROFILE:
      {
        return {
          ...state,
          isUserEditProfile: true
        };
      }
    case types.SET_SHOW_TOAST:
      {
        return {
          ...state,
          showToast: action.payload
        };
      }
    default:
      return state;
  }
};